<template>
  <div class="session-report-new">
    <div class="sr-layout">
      <!-- 左侧导航 -->
      <aside class="sr-sidebar">
        <div class="sr-sidebar-tabs">
          <span
            v-for="tab in topTabs"
            :key="tab.key"
            :class="['sr-tab', { active: activeTab === tab.key }]"
            @click="activeTab = tab.key"
          >
            {{ tab.label }}
          </span>
        </div>
        <div class="sr-sidebar-menu">
          <div
            v-for="group in menuGroups"
            :key="group.title"
            class="sr-menu-group"
          >
            <div
              class="sr-menu-group-title"
              @click="toggleGroup(group.key)"
            >
              <i :class="['el-icon-arrow-down', { collapsed: !openGroups[group.key] }]"></i>
              {{ group.title }}
            </div>
            <div v-show="openGroups[group.key]" class="sr-menu-items">
              <div
                v-for="item in group.items"
                :key="item.key"
                :class="['sr-menu-item', { active: currentReport === item.key }]"
                @click="selectReport(item.key)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </aside>

      <!-- 主内容区 -->
      <main class="sr-main">
        <!-- 筛选栏 -->
        <div class="sr-filter-bar">
          <span class="sr-filter-label">时间</span>
          <date-time-range-picker v-model="dateRange" class="sr-time-picker" @change="onDateChange" />
          <el-checkbox v-model="filterForm.compare" size="small" style="margin-right: 16px">对比</el-checkbox>
          <!-- <span class="sr-filter-label">账号</span>
          <el-select v-model="filterForm.account" size="small" placeholder="全部" style="width: 100px; margin-right: 16px">
            <el-option label="全部" value="all" />
          </el-select>
          <span class="sr-filter-label">请求方式</span>
          <el-select v-model="filterForm.requestMethod" size="small" placeholder="全部" style="width: 100px; margin-right: 16px">
            <el-option label="全部" value="all" />
          </el-select> -->
          <!-- <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">筛选</el-button> -->
          <el-checkbox v-model="showChart" size="small" class="sr-show-chart">显示图表</el-checkbox>
        </div>

        <!-- 图表区域 -->
        <div v-show="showChart" class="sr-chart-section">
          <div class="sr-chart-toolbar">
            <el-radio-group v-model="chartType" size="small">
              <el-radio-button label="trend">趋势图</el-radio-button>
              <el-radio-button label="bar">柱状图</el-radio-button>
              <el-radio-button label="pie">饼状图</el-radio-button>
            </el-radio-group>
            <div class="sr-chart-options">
              <span class="sr-option-label">指标设置</span>
              <el-select v-model="chartMetric" size="mini" placeholder="数量指标" style="width: 100px; margin-left: 8px">
                <el-option label="数量指标" value="count" />
              </el-select>
              <el-select v-model="chartTop" size="mini" placeholder="top10" style="width: 80px; margin-left: 8px">
                <el-option label="top10" value="10" />
              </el-select>
            </div>
          </div>
          <div v-show="chartType === 'pie'" class="sr-pie-charts">
            <div class="sr-pie-box">
              <div ref="pieTotalRef" class="sr-pie-canvas"></div>
              <div class="sr-pie-title">总对话饼状图</div>
              <div class="sr-pie-legend">
                <span class="sr-pie-legend-dot"></span>
                <span>{{ dateRangeText }}</span>
              </div>
            </div>
            <div class="sr-pie-box">
              <div ref="pieOpenRef" class="sr-pie-canvas"></div>
              <div class="sr-pie-title">开口对话饼状图</div>
              <div class="sr-pie-legend">
                <span class="sr-pie-legend-dot"></span>
                <span>{{ dateRangeText }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 数据明细 -->
        <div class="sr-table-section">
          <div class="sr-table-header">
            <h3 class="sr-table-title">数据明细</h3>
            <div class="sr-table-actions">
              <el-dropdown trigger="click" @command="onCustomColumn">
                <span class="sr-link">
                  自定义列 <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="toggle">显示/隐藏列</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="small" @click="onExport">导出</el-button>
            </div>
          </div>
          <div class="sr-table-wrap">
            <el-table
              v-loading="tbLoading"
              :data="tableData"
              border
              stripe
              size="small"
              style="width: 100%"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
            >
              <el-table-column prop="date" :label="firstColumnLabel" width="120" align="center">
                <template slot="header">
                  <span>{{ firstColumnLabel }}</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="browseCount" label="浏览数" min-width="90" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>浏览数</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="talkCount" label="对话数" min-width="90" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>对话数</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="talkRate" label="对话率" min-width="90" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>对话率</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="transferCount" label="转潜数" min-width="90" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>转潜数</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="transferRate" label="转潜率" min-width="90" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>转潜率</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="browseTransferRate" label="浏览转潜率" min-width="100" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>浏览转潜率</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="oneSentenceCount" label="一句话对话数量" min-width="120" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>一句话对话数量</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="oneSentenceRate" label="一句话对话占比" min-width="120" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>一句话对话占比</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="threeSentenceCount" label="三句话以内对话数量" min-width="140" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>三句话以内对话数量</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
              <el-table-column prop="threeSentenceRate" label="三句话以内对话占比" min-width="140" align="center" show-overflow-tooltip>
                <template slot="header">
                  <span>三句话以内对话占比</span>
                  <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer"></i>
                  <i class="el-icon-sort" style="margin-left: 2px; color: #909399; cursor: pointer"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="sr-pagination">
            <el-pagination
              :current-page="pagination.page"
              :page-size="pagination.pageSize"
              :page-sizes="[20, 50, 100]"
              :total="pagination.total"
              layout="total, sizes, prev, pager, next"
              @size-change="onSizeChange"
              @current-change="onPageChange"
            />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";

// 渠道访客选项（写死，与 chatForm sourceMap 一致；key 为 value 字符串，接口传 currentReport）
const CHANNEL_VISITOR_ITEMS = [
  { key: "0", label: "其他" },
  { key: "1", label: "百度" },
  { key: "2", label: "360" },
  { key: "3", label: "搜狗" },
  { key: "4", label: "神马" },
  { key: "7", label: "快手" },
];

// 按时段：24 个整点时段（合计 + 23:00-24:00 到 00:00-01:00）
const TIME_SLOTS_24 = [
  "合计",
  "23:00-24:00",
  "22:00-23:00",
  "21:00-22:00",
  "20:00-21:00",
  "19:00-20:00",
  "18:00-19:00",
  "17:00-18:00",
  "16:00-17:00",
  "15:00-16:00",
  "14:00-15:00",
  "13:00-14:00",
  "12:00-13:00",
  "11:00-12:00",
  "10:00-11:00",
  "09:00-10:00",
  "08:00-09:00",
  "07:00-08:00",
  "06:00-07:00",
  "05:00-06:00",
  "04:00-05:00",
  "03:00-04:00",
  "02:00-03:00",
  "01:00-02:00",
  "00:00-01:00",
];

export default {
  name: "SessionReportNew",
  components: {
    DateTimeRangePicker,
  },
  data() {
    return {
      activeTab: "report",
      topTabs: [
        { key: "report", label: "报表" },
        { key: "category", label: "分类" },
        { key: "manage", label: "管理" },
      ],
      openGroups: {
        preset: false,
        web: false,
        robot: false,
        performance: false,
        channel: true,
      },
      menuGroups: [
        {
          key: "preset",
          title: "预置报表",
          items: [
            { key: "sop", label: "SOP唤醒分析" },
            { key: "worktime", label: "工作时长" },
          ],
        },
        {
          key: "web",
          title: "网页访客",
          items: [
            { key: "baidu-account", label: "百度账户数据" },
            { key: "bytime", label: "按时段" },
            { key: "byengine", label: "按搜索引擎" },
            { key: "bysource", label: "按来源类型" },
            { key: "byarea", label: "按来源省市" },
            { key: "bykeyword", label: "按关键字" },
          ],
        },
        {
          key: "channel",
          title: "渠道访客",
          items: CHANNEL_VISITOR_ITEMS,
        },
      ],
      currentReport: "1",
      dateRange: null,
      filterForm: {
        compare: false,
        account: "all",
        requestMethod: "all",
      },
      showChart: true,
      chartType: "pie",
      chartMetric: "count",
      chartTop: "10",
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 1,
      },
      pieTotalChart: null,
      pieOpenChart: null,
      tbLoading: false,
    };
  },
  computed: {
    dateRangeText() {
      if (!this.dateRange || !this.dateRange.length) return "";
      return this.dateRange[0] ? this.dateRange[0].split(" ")[0] : "";
    },
    firstColumnLabel() {
      const map = {
        "baidu-account": "百度账号",
        bytime: "时段",
        byengine: "搜索引擎",
        bysource: "来源类型",
        byarea: "来源省市",
        bykeyword: "对话关键字",
      };
      return map[this.currentReport] || "日期";
    },
  },
  created() {
    this.setDefaultDate();
    this.loadTableData();
  },
  mounted() {
    this.$nextTick(() => {
      this.initPieCharts();
    });
    window.addEventListener("resize", this.resizeCharts);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCharts);
    if (this.pieTotalChart) this.pieTotalChart.dispose();
    if (this.pieOpenChart) this.pieOpenChart.dispose();
  },
  methods: {
    setDefaultDate() {
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
      this.dateRange = [
        this.formatDateTime(start),
        this.formatDateTime(end),
      ];
    },
    formatDateTime(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${y}-${m}-${day} ${h}:${min}`;
    },
    toggleGroup(key) {
      this.$set(this.openGroups, key, !this.openGroups[key]);
    },
    selectReport(key) {
      this.currentReport = key;
      this.loadTableData();
    },
    onDateChange() {
      this.loadTableData();
    },
    onFilter() {
      this.loadTableData();
    },
    onCustomColumn() {
      this.$message.info("自定义列功能");
    },
    onExport() {
      this.$message.success("导出功能可在此对接");
    },
    isChannelReport() {
      return CHANNEL_VISITOR_ITEMS.some((i) => i.key === this.currentReport);
    },
    isByAreaReport() {
      return this.currentReport === "byarea";
    },
    isByEngineReport() {
      return this.currentReport === "byengine";
    },
    isByKeywordReport() {
      return this.currentReport === "bykeyword";
    },
    isBaiduAccountReport() {
      return this.currentReport === "baidu-account";
    },
    isByTimeReport() {
      return this.currentReport === "bytime";
    },
    parseDateRange() {
      if (!this.dateRange || this.dateRange.length !== 2) return null;
      const startStr = this.dateRange[0];
      const endStr = this.dateRange[1];
      if (!startStr || !endStr) return null;
      const [startDatePart] = startStr.split(" ");
      const [endDatePart] = endStr.split(" ");
      return { startDatePart, endDatePart };
    },
    getDatesInRange(startDateStr, endDateStr) {
      const dates = [];
      const start = new Date(startDateStr);
      const end = new Date(endDateStr);
      const curr = new Date(start);
      while (curr <= end) {
        const y = curr.getFullYear();
        const m = String(curr.getMonth() + 1).padStart(2, "0");
        const d = String(curr.getDate()).padStart(2, "0");
        dates.push(`${y}-${m}-${d}`);
        curr.setDate(curr.getDate() + 1);
      }
      return dates;
    },
    mapSummaryToRow(summary, dateLabel) {
      if (!summary) {
        return {
          date: dateLabel,
          browseCount: "0",
          talkCount: "0",
          talkRate: "0%",
          transferCount: "0",
          transferRate: "0%",
          browseTransferRate: "0%",
          oneSentenceCount: "0",
          oneSentenceRate: "0%",
          threeSentenceCount: "0",
          threeSentenceRate: "0%",
        };
      }
      const zqCount = summary.zhuanqianCount ?? summary.zhuangqianCount ?? 0;
      const zqRate = summary.zhuanqianRate ?? summary.zhuangqianRate ?? "0%";
      const zqBrowseRate = summary.zhuanqianBrowseRate ?? summary.zhuangqianBrowseRate ?? "0%";
      return {
        date: dateLabel,
        browseCount: String(summary.browseCount ?? "0"),
        talkCount: String(summary.dialogueCount ?? "0"),
        talkRate: summary.dialogueRate ?? "0%",
        transferCount: String(zqCount),
        transferRate: zqRate,
        browseTransferRate: zqBrowseRate,
        oneSentenceCount: String(summary.oneSentenceCount ?? "0"),
        oneSentenceRate: summary.oneSentenceRate ?? "0%",
        threeSentenceCount: String(summary.threeSentenceCount ?? "0"),
        threeSentenceRate: summary.threeSentenceRate ?? "0%",
      };
    },
    // 从 hourTimeDesc（如 "2025-02-26 00:00-01:00"）提取时段 "00:00-01:00"
    getSlotKeyFromHourTimeDesc(hourTimeDesc) {
      if (!hourTimeDesc || typeof hourTimeDesc !== "string") return "";
      const parts = hourTimeDesc.trim().split(/\s+/);
      return parts.length >= 2 ? parts[1] : hourTimeDesc;
    },
    // 将同一时段多天的 summary 聚合成一个 summary（累加 count，率按合计重算）
    aggregateSummaries(items) {
      let browseCount = 0;
      let dialogueCount = 0;
      let zhuanqianCount = 0;
      for (const it of items) {
        const s = it.summary || {};
        browseCount += Number(s.browseCount) || 0;
        dialogueCount += Number(s.dialogueCount) || 0;
        zhuanqianCount += Number(s.zhuanqianCount ?? s.zhuangqianCount) || 0;
      }
      const dialogueRate = browseCount ? ((dialogueCount / browseCount) * 100).toFixed(2) + "%" : "0%";
      const zhuanqianRate = dialogueCount ? ((zhuanqianCount / dialogueCount) * 100).toFixed(2) + "%" : "0%";
      const zhuanqianBrowseRate = browseCount ? ((zhuanqianCount / browseCount) * 100).toFixed(2) + "%" : "0%";
      return {
        browseCount,
        dialogueCount,
        dialogueRate,
        zhuanqianCount,
        zhuanqianRate,
        zhuanqianBrowseRate,
      };
    },
    async loadChannelData() {
      const range = this.parseDateRange();
      if (!range) {
        this.tableData = [];
        this.pagination.total = 0;
        return;
      }
      const dates = this.getDatesInRange(range.startDatePart, range.endDatePart);
      const source = parseInt(this.currentReport, 10);
      const rows = [];
      this.tbLoading = true;
      try {
        for (const dateStr of dates) {
          const startTime = Math.floor(new Date(dateStr + " 00:00:00").getTime() / 1000);
          const endTime = Math.floor(new Date(dateStr + " 23:59:59").getTime() / 1000);
          const res = await this.util.postRequest({
            url: "/manager/reporttable/query",
            method: "POST",
            data: {
              source,
              startTime: String(startTime),
              endTime: String(endTime),
              page: 1,
              size: 100,
              customerStatus: 1,
              columnsFilter: {},
            },
          });
          if (res.resultCode === "10000" && res.data && res.data.summaryData) {
            rows.push(this.mapSummaryToRow(res.data.summaryData, dateStr));
          } else {
            rows.push(this.mapSummaryToRow(null, dateStr));
          }
        }
        const totalStart = Math.floor(new Date(range.startDatePart + " 00:00:00").getTime() / 1000);
        const totalEnd = Math.floor(new Date(range.endDatePart + " 23:59:59").getTime() / 1000);
        const totalRes = await this.util.postRequest({
          url: "/manager/reporttable/query",
          method: "POST",
          data: {
            source,
            startTime: String(totalStart),
            endTime: String(totalEnd),
            page: 1,
            size: 100,
            customerStatus: 1,
            columnsFilter: {},
          },
        });
        let totalRow = this.mapSummaryToRow(null, "合计");
        if (totalRes.resultCode === "10000" && totalRes.data && totalRes.data.summaryData) {
          totalRow = this.mapSummaryToRow(totalRes.data.summaryData, "合计");
        }
        this.tableData = [totalRow, ...rows];
        this.pagination.total = this.tableData.length;
      } catch (e) {
        this.$message.error("加载数据失败");
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.tbLoading = false;
      }
    },
    getBaseQueryBody(startTime, endTime) {
      return {
        startTime: String(startTime),
        endTime: String(endTime),
        page: 1,
        size: 100,
        customerStatus: 1,
        columnsFilter: {},
      };
    },
    async loadByColumnData(columnKey) {
      const range = this.parseDateRange();
      if (!range) {
        this.tableData = [];
        this.pagination.total = 0;
        return;
      }
      const totalStart = Math.floor(new Date(range.startDatePart + " 00:00:00").getTime() / 1000);
      const totalEnd = Math.floor(new Date(range.endDatePart + " 23:59:59").getTime() / 1000);
      this.tbLoading = true;
      try {
        const totalRes = await this.util.postRequest({
          url: "/manager/reporttable/query",
          method: "POST",
          data: this.getBaseQueryBody(totalStart, totalEnd),
        });
        let totalRow = this.mapSummaryToRow(null, "合计");
        const uniqueValues = [];
        if (totalRes.resultCode === "10000" && totalRes.data) {
          if (totalRes.data.summaryData) {
            totalRow = this.mapSummaryToRow(totalRes.data.summaryData, "合计");
          }
          const columnsData = totalRes.data.columnsData || [];
          const seen = new Set();
          for (const row of columnsData) {
            const val = row[columnKey];
            const key = val === undefined || val === null || val === "" ? "__empty__" : String(val);
            if (!seen.has(key)) {
              seen.add(key);
              uniqueValues.push(val === undefined || val === null || val === "" ? null : val);
            }
          }
        }
        const rows = [];
        for (const colValue of uniqueValues) {
          const filter = colValue === null ? { [columnKey]: "" } : { [columnKey]: colValue };
          const res = await this.util.postRequest({
            url: "/manager/reporttable/query",
            method: "POST",
            data: {
              ...this.getBaseQueryBody(totalStart, totalEnd),
              columnsFilter: filter,
            },
          });
          const label = colValue === null ? "未知" : colValue;
          if (res.resultCode === "10000" && res.data && res.data.summaryData) {
            rows.push(this.mapSummaryToRow(res.data.summaryData, label));
          } else {
            rows.push(this.mapSummaryToRow(null, label));
          }
        }
        this.tableData = [totalRow, ...rows];
        this.pagination.total = this.tableData.length;
      } catch (e) {
        this.$message.error("加载数据失败");
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.tbLoading = false;
      }
    },
    loadByAreaData() {
      return this.loadByColumnData("fromregion");
    },
    loadByEngineData() {
      return this.loadByColumnData("source");
    },
    loadByKeywordData() {
      return this.loadByColumnData("keyword");
    },
    loadBaiduAccountData() {
      return this.loadByColumnData("adusername");
    },
    async loadByTimeData() {
      const range = this.parseDateRange();
      if (!range) {
        this.tableData = [];
        this.pagination.total = 0;
        return;
      }
      const totalStart = Math.floor(new Date(range.startDatePart + " 00:00:00").getTime() / 1000);
      const totalEnd = Math.floor(new Date(range.endDatePart + " 23:59:59").getTime() / 1000);
      this.tbLoading = true;
      try {
        const res = await this.util.postRequest({
          url: "/manager/reporttable/queryHourlySummaryByCondition",
          method: "POST",
          data: {
            startTime: String(totalStart),
            endTime: String(totalEnd),
          },
        });
        if (res.resultCode !== "10000" || !Array.isArray(res.data)) {
          const rows = TIME_SLOTS_24.map((slotLabel) => this.mapSummaryToRow(null, slotLabel));
          this.tableData = rows;
          this.pagination.total = rows.length;
          return;
        }
        const list = res.data;
        const bySlot = {};
        for (const item of list) {
          const slotKey = this.getSlotKeyFromHourTimeDesc(item.hourTimeDesc);
          if (!slotKey) continue;
          if (!bySlot[slotKey]) bySlot[slotKey] = [];
          bySlot[slotKey].push(item);
        }
        const slotOrder = TIME_SLOTS_24.filter((s) => s !== "合计");
        const rows = [];
        let totalBrowse = 0;
        let totalDialogue = 0;
        let totalTransfer = 0;
        for (const slotLabel of slotOrder) {
          const items = bySlot[slotLabel] || [];
          const agg = items.length ? this.aggregateSummaries(items) : null;
          totalBrowse += Number(agg?.browseCount) || 0;
          totalDialogue += Number(agg?.dialogueCount) || 0;
          totalTransfer += Number(agg?.zhuanqianCount) || 0;
          rows.push(this.mapSummaryToRow(agg, slotLabel));
        }
        const totalSummary = {
          browseCount: totalBrowse,
          dialogueCount: totalDialogue,
          dialogueRate: totalBrowse ? ((totalDialogue / totalBrowse) * 100).toFixed(2) + "%" : "0%",
          zhuanqianCount: totalTransfer,
          zhuanqianRate: totalDialogue ? ((totalTransfer / totalDialogue) * 100).toFixed(2) + "%" : "0%",
          zhuanqianBrowseRate: totalBrowse ? ((totalTransfer / totalBrowse) * 100).toFixed(2) + "%" : "0%",
        };
        this.tableData = [this.mapSummaryToRow(totalSummary, "合计"), ...rows];
        this.pagination.total = this.tableData.length;
      } catch (e) {
        this.$message.error("加载按时段数据失败");
        const rows = TIME_SLOTS_24.map((slotLabel) => this.mapSummaryToRow(null, slotLabel));
        this.tableData = rows;
        this.pagination.total = rows.length;
      } finally {
        this.tbLoading = false;
      }
    },
    loadTableData() {
      if (this.isChannelReport()) {
        this.loadChannelData();
        return;
      }
      if (this.isByAreaReport()) {
        this.loadByAreaData();
        return;
      }
      if (this.isByEngineReport()) {
        this.loadByEngineData();
        return;
      }
      if (this.isByKeywordReport()) {
        this.loadByKeywordData();
        return;
      }
      if (this.isBaiduAccountReport()) {
        this.loadBaiduAccountData();
        return;
      }
      if (this.isByTimeReport()) {
        this.loadByTimeData();
        return;
      }
      const dateStr = this.dateRangeText || "2026-03-10";
      this.tableData = [
        {
          date: "合计",
          browseCount: "0",
          talkCount: "0",
          talkRate: "0%",
          transferCount: "0",
          transferRate: "0%",
          browseTransferRate: "0%",
          oneSentenceCount: "0",
          oneSentenceRate: "0%",
          threeSentenceCount: "0",
          threeSentenceRate: "0%",
        },
        {
          date: dateStr,
          browseCount: "0",
          talkCount: "0",
          talkRate: "0%",
          transferCount: "0",
          transferRate: "0%",
          browseTransferRate: "0%",
          oneSentenceCount: "0",
          oneSentenceRate: "0%",
          threeSentenceCount: "0",
          threeSentenceRate: "0%",
        },
      ];
      this.pagination.total = this.tableData.length;
    },
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.loadTableData();
    },
    onPageChange(val) {
      this.pagination.page = val;
      this.loadTableData();
    },
    initPieCharts() {
      if (this.$refs.pieTotalRef) {
        this.pieTotalChart = echarts.init(this.$refs.pieTotalRef);
        this.pieTotalChart.setOption({
          tooltip: { trigger: "item" },
          series: [
            {
              type: "pie",
              radius: ["40%", "70%"],
              avoidLabelOverlap: false,
              itemStyle: { borderColor: "#fff", borderWidth: 2 },
              label: { show: false },
              data: [{ value: 0, name: "总对话", itemStyle: { color: "#b3d8ff" } }],
            },
          ],
        });
      }
      if (this.$refs.pieOpenRef) {
        this.pieOpenChart = echarts.init(this.$refs.pieOpenRef);
        this.pieOpenChart.setOption({
          tooltip: { trigger: "item" },
          series: [
            {
              type: "pie",
              radius: ["40%", "70%"],
              avoidLabelOverlap: false,
              itemStyle: { borderColor: "#fff", borderWidth: 2 },
              label: { show: false },
              data: [{ value: 0, name: "开口对话", itemStyle: { color: "#b3d8ff" } }],
            },
          ],
        });
      }
    },
    resizeCharts() {
      this.pieTotalChart && this.pieTotalChart.resize();
      this.pieOpenChart && this.pieOpenChart.resize();
    },
  },
};
</script>

<style scoped lang="scss">
/* 整页占满视口，高度链明确，避免 flex 子项高度为 0 */
.session-report-new {
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}
.sr-layout {
  flex: 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}
.sr-sidebar {
  width: 220px;
  min-width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sr-sidebar-tabs {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #e4e7ed;
  .sr-tab {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    &.active {
      color: #409eff;
      font-weight: 600;
    }
  }
}
.sr-sidebar-menu {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.sr-menu-group {
  .sr-menu-group-title {
    padding: 8px 16px;
    font-size: 13px;
    color: #303133;
    cursor: pointer;
    display: flex;
    align-items: center;
    .el-icon-arrow-down {
      margin-right: 6px;
      transition: transform 0.2s;
      &.collapsed {
        transform: rotate(-90deg);
      }
    }
  }
  .sr-menu-item {
    padding: 8px 16px 8px 28px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
      color: #409eff;
    }
    &.active {
      background: #ecf5ff;
      color: #409eff;
    }
  }
}
.sr-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px;
  background: #f5f7fa;
}
.sr-filter-bar {
  flex-shrink: 0;
  background: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .sr-filter-label {
    font-size: 13px;
    color: #606266;
    margin-right: 8px;
  }
  .sr-show-chart {
    margin-left: auto;
  }
  .sr-time-picker {
    margin-right: 16px;
  }
}
.sr-chart-section {
  flex-shrink: 0;
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}
.sr-chart-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .sr-chart-options {
    display: flex;
    align-items: center;
    .sr-option-label {
      font-size: 13px;
      color: #606266;
    }
  }
}
.sr-pie-charts {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}
.sr-pie-box {
  flex: 1;
  min-width: 280px;
  max-width: 400px;
  text-align: center;
  .sr-pie-canvas {
    width: 100%;
    height: 260px;
  }
  .sr-pie-title {
    font-size: 14px;
    color: #303133;
    margin-top: 8px;
  }
  .sr-pie-legend {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    .sr-pie-legend-dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #409eff;
      margin-right: 6px;
      vertical-align: middle;
    }
  }
}
.sr-table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  overflow: hidden;
}
.sr-table-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  .sr-table-title {
    margin: 0;
    font-size: 16px;
    color: #303133;
  }
  .sr-table-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    .sr-link {
      font-size: 13px;
      color: #409eff;
      cursor: pointer;
    }
  }
}
/* 表格占剩余空间并内部滚动；设最小高度避免被压成 0 看不到数据 */
.sr-table-wrap {
  flex: 1;
  min-height: 240px;
  overflow: auto;
}
.sr-pagination {
  flex-shrink: 0;
  height: 56px;
  margin-top: 12px;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #fff;
  border-top: 1px solid #ebeef5;
}
</style>
